import ImgCategoryGolf from "../images/product_category_golf.jpg";
import ImgCategoryCamera from "../images/product_category_camera.jpg";
import ImgCategoryHospital from "../images/product_category_hospital.jpg";
import ImgCategorySoftware from "../images/product_category_software.jpg";
import ImgCategoryAttached from "../images/product_category_attached.jpg";
import ImgCategoryHardware from "../images/product_category_hardware.jpg";

export const CategoryList = [
  {
    tileType: "category001",
    href: "/product/category/",
    txt: "ゴルフ関連製品",
    img: ImgCategoryGolf,
  },
  {
    tileType: "category002",
    href: "/product/category/",
    txt: "カメラ関連製品",
    img: ImgCategoryCamera,
  },
  {
    tileType: "category003",
    href: "/product/category/",
    txt: "医療関連製品",
    img: ImgCategoryHospital,
  },
  {
    tileType: "category004",
    href: "/product/category/",
    txt: "ソフトウェア",
    img: ImgCategorySoftware,
  },
  {
    tileType: "category005",
    href: "/product/category/",
    txt: "付属ソフト",
    img: ImgCategoryAttached,
  },
  {
    tileType: "category006",
    href: "/product/category/",
    txt: "ハードウェア",
    img: ImgCategoryHardware,
  },
];
